<template>
  <div id="login">
    <section class="bannerprincipal">
      <div class="">
        <div class="row">
          <div class="col-12 col-md-12 offset-md-0 h-100 pb-5">
            <div class="">
              <div
                class="d-flex justify-content-center align-items-center fanta amarillo fXG"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="px-3 px-lg-0 mb-5">
      <div class="pt-5">
        <div class="row pasos text-center">
          <div class="col-lg-6 d-none d-lg-block" data-aos="fade-up" data-aos-delay="200">
            <img
              src="../assets/imgs/verano23/mnms-verano.png"
              alt="Verano Cinépolis"
              class="img-fluid"
            />
          </div>

          <div class="col-lg-6 px-lg-5">
            <div class="row pr-lg-5 pt-5 pt-lg-0 mt-5 mt-lg-4">
              <div class="col-12 pb-3">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-6" data-aos="fade-right" :data-aos-delay="basedelay + 200">
                    <img
                      src="../assets/imgs/verano23/pasos/paso1.png"
                      alt="paso1"
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-6" data-aos="fade-left" :data-aos-delay="basedelay + 200">
                    <img
                      src="../assets/imgs/verano23/pasos/combo1.png"
                      alt="paso1"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 pb-3">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-6" data-aos="fade-right" :data-aos-delay="basedelay + 400">
                    <img
                      src="../assets/imgs/verano23/pasos/combo2.png"
                      alt="paso1"
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-6" data-aos="fade-left" :data-aos-delay="basedelay + 400">
                    <img
                      src="../assets/imgs/verano23/pasos/paso2.png"
                      alt="paso1"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 pb-3">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-6" data-aos="fade-right" :data-aos-delay="basedelay + 600">
                    <img
                      src="../assets/imgs/verano23/pasos/paso3.png"
                      alt="paso1"
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-6" data-aos="fade-left" :data-aos-delay="basedelay + 600">
                    <img
                      src="../assets/imgs/verano23/pasos/combo3.png"
                      alt="paso1"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";

import mobile from "is-mobile";

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        club_cinepolis: ""
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      basedelay: 200
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      //disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);

    //console.log({mobile: mobile()});
    if(mobile()){
      this.basedelay = 400;
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.registro();
    },
    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
